import { render, staticRenderFns } from "./convocatoria.vue?vue&type=template&id=427c3dd4&"
import script from "./convocatoria.component.ts?vue&type=script&lang=ts&"
export * from "./convocatoria.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports